import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import {
  getContestInvestigationSummary,
  searchContestInvestigationSummary,
} from "@/Api/contests";
import { TableData } from "@/App/ContestInvestigationSummary/Table";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";

export type AwardedClientProps = {
  contest_id: number;
  client_id: number;
  client_name: string;
  client_document: string;
  client_phone: string;
  total_invested: string;
  total_entries: number;
  is_winner: number;
  prize_amount: string;
};

export type TableDataProps = {
  contest_id: number;
  contest_name: string;
  lottery_name: string;
  contest_validation_date: string;
  lottery_color: string;
  total_investigation: number;
  total_price_per_share: number;
  created_at: string;
  clients: AwardedClientProps[];
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  useEffect(() => {
    (async () => {
      const { data } = await getContestInvestigationSummary();
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getContestInvestigationSummary(
          listData?.current_page + 1
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getContestInvestigationSummary(
          listData?.current_page - 1
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getContestInvestigationSummary(
          listData?.last_page
        );
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-awards-list")}>
        <div className="flex justify-center md:justify-between items-center flex-wrap gap-2">
          <h2 className="text-2xl font-semibold flex gap-2 items-center">
            Lista de Prêmios
          </h2>
        </div>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={searchContestInvestigationSummary}
            placeholder="Pesquisar prêmios"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={6} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
